import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import resources from '../i18n'

i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false
    }
  });
